import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../firebase";
import { collection, getDocs, query, orderBy, limit } from "firebase/firestore";
import "../styles/View.css";

function Viewsptxt() {
  const [reviews, setReviews] = useState([]);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("all");
  const navigate = useNavigate();
  const [selectedImage, setSelectedImage] = useState(null);
  const [dateRangeByHotel, setDateRangeByHotel] = useState({});

  useEffect(() => {
    async function fetchReviews() {
      const reviewsQuery = query(
        collection(db, "reviews"),
        orderBy("createdAt", "desc"),
      );
      const querySnapshot = await getDocs(reviewsQuery);
      const reviewList = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setReviews(reviewList);
    }

    async function fetchUsers() {
      const usersSnapshot = await getDocs(collection(db, "users"));
      const userList = usersSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setUsers(userList); // ✅ store users
    }

    fetchReviews();
    fetchUsers(); // ✅ also fetch users
  }, []);


  const groupedData = reviews.reduce((acc, review) => {
    const hotel = review.hotelName || "Unknown Hotel";
    const email = review.userEmail || "Unknown Email";

    if (!acc[hotel]) acc[hotel] = {};
    if (!acc[hotel][email]) acc[hotel][email] = [];

    acc[hotel][email].push(review);
    return acc;
  }, {});

  // Sort (no cap — keep all records so date filters aren't starved)
  Object.keys(groupedData).forEach((hotel) => {
    Object.keys(groupedData[hotel]).forEach((email) => {
      groupedData[hotel][email] = groupedData[hotel][email]
        .sort((a, b) => b.createdAt?.toMillis?.() - a.createdAt?.toMillis?.());
    });
  });

  const handleDateRangeChange = (hotel, field, value) => {
    setDateRangeByHotel((prev) => ({
      ...prev,
      [hotel]: {
        ...(prev[hotel] || {}),
        [field]: value,
      },
    }));
  };

  const getFilteredHotelReviews = (hotel, email) => {
    const range = dateRangeByHotel[hotel] || {};
    const hasCustomRange = Boolean(range.from || range.to);

    let startDate = range.from ? new Date(`${range.from}T00:00:00`) : null;
    const endDate = range.to ? new Date(`${range.to}T23:59:59`) : null;

    // ✅ Default to last 7 days when no custom date range has been picked
    if (!hasCustomRange) {
      startDate = new Date();
      startDate.setDate(startDate.getDate() - 7);
      startDate.setHours(0, 0, 0, 0);
    }

    const sourceReviews = email === "all"
      ? Object.keys(groupedData[hotel] || {})
          .filter((reviewEmail) => {
            const user = users.find((u) => u.email === reviewEmail);
            return user?.role?.toLowerCase() === "security";
          })
          .flatMap((reviewEmail) => groupedData[hotel][reviewEmail] || [])
      : groupedData[hotel]?.[email] || [];

    return sourceReviews.filter((review) => {
      const reviewDate = review.createdAt?.toDate ? review.createdAt.toDate() : null;
      if (!reviewDate) return false;
      if (startDate && reviewDate < startDate) return false;
      if (endDate && reviewDate > endDate) return false;
      return true;
    }).sort((a, b) => b.createdAt?.toMillis?.() - a.createdAt?.toMillis?.());
  };

  // ✅ Top 10 recent records
  const recent10 = [...reviews]
    .sort((a, b) => b.createdAt?.toMillis?.() - a.createdAt?.toMillis?.())
    .filter((review) => {
      const user = users.find((u) => u.email === review.userEmail);
      return (
        review.hotelName?.toLowerCase() === "sarathchandra textile".toLowerCase() &&
        user?.role?.toLowerCase() === "security"
      );
    })
    .slice(0, 10);


  return (
    <div className="admin-container">
      <h2 style={{color:"black"}}> Latest Security Reviews</h2>

      <button className="home-button" onClick={() => navigate("/txtsadmin")}>
            Back
       </button>

      
       {/* ✅ Show top 10 recent records */}
      <div className="recent-section">
        <h3>Recently Submitted (Last 10)</h3>
        <div className="table">
          <table className="review-table">
            <thead>
              <tr>
                {/* <th>NO</th> */}
                <th>Date</th>               
                <th>QR Data</th>
                <th>User</th>
                <th>Rating</th>
                <th>Company Issues</th>
                <th>Maintenance Issues</th>
                <th>Image</th>
                {/* <th>User IP</th> */}
                <th>Location</th>
                
              </tr>
            </thead>
           <tbody>
            {recent10.map((review, index) => {
              const reviewDate = review.createdAt?.toDate ? review.createdAt.toDate() : null;

                  // Check if the review was submitted today
                  const isToday =
                    reviewDate &&
                    reviewDate.toDateString() === new Date().toDateString();

                  // ✅ Format date as DD/MM/YYYY and time as HH:mm:ss (24h)
                  const formattedDateTime = reviewDate
                  ? `${reviewDate.toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit" })} ${reviewDate.toLocaleTimeString("en-GB", {
                      hour: "2-digit",
                      minute: "2-digit",
                      second: "2-digit",
                    })}`
                  : "";

                  return (
                    <tr
                      key={review.id}
                      className={`
                       
                        ${isToday ? "today-review" : "older-review"}
                      `}
                      >

                  {/* <td>{index + 1}</td> */}
                  <td>{formattedDateTime}</td>
                  <td>{review.qrData || "N/A"}</td>
                  <td>{review.userEmail ? review.userEmail.split('@')[0] : "Unknown"}</td>                  
                  <td>{review.rating}/5</td>
                  <td>{review.issueHotel}</td>
                  <td>{review.issueMaintenance}</td>
                  <td>
                     {review.imageUrls && review.imageUrls.length > 0 ? (
                        <div className="thumbnail-row">
                          {review.imageUrls.map((url, idx) => (
                            <img
                              key={idx}
                              src={url}
                              alt={`Uploaded ${idx + 1}`}
                              className="review-thumbnail"
                              onClick={() => setSelectedImage(url)} // open popup
                            />
                          ))}
                        </div>
                      ) : (
                        "No image"
                      )}
                  </td>
                  {/* <td>{review.userIp || "Unknown"}</td> */}
                  <td>
                    {review.location?.lat && review.location?.lng ? (
                      <a
                        href={`https://www.google.com/maps?q=${review.location.lat},${review.location.lng}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View Location
                      </a>
                    ) : (
                      "No Location"
                    )}
                  </td>
                 
                </tr>
              );
            })}
          </tbody>

          </table>
        </div>
      </div><br></br>

     {Object.keys(groupedData)
        .filter((hotel) => hotel === "Sarathchandra Textile") // ✅ only this hotel
        .map((hotel) => (
            <div key={hotel} className="hotel-section">
            <h3>{hotel}</h3>

<div className="table">
                <div className="date-range-filter">
                  <span className="date-range-label">📅 Select date range</span>
                  {!(dateRangeByHotel[hotel]?.from || dateRangeByHotel[hotel]?.to) && (
                    <span className="range-default-badge">Showing last 7 days</span>
                  )}
                  <label className="date-input-group">
                    <span>From</span>
                    <input
                      type="date"
                      value={dateRangeByHotel[hotel]?.from || ""}
                      onChange={(e) => handleDateRangeChange(hotel, "from", e.target.value)}
                    />
                  </label>
                  <label className="date-input-group">
                    <span>To</span>
                    <input
                      type="date"
                      value={dateRangeByHotel[hotel]?.to || ""}
                      onChange={(e) => handleDateRangeChange(hotel, "to", e.target.value)}
                    />
                  </label>
                  <button
                    type="button"
                    className="clear-date-btn"
                    onClick={() =>
                      setDateRangeByHotel((prev) => ({
                        ...prev,
                        [hotel]: { from: "", to: "" },
                      }))
                    }
                  >
                    Clear
                  </button>
                </div>

                {/* User Tabs - only security users */}
                <div className="tab-container">
                  <button
                    type="button"
                    className={`tab-btn ${selectedUser === "all" ? "active selected-email" : ""}`}
                    onClick={() => setSelectedUser("all")}
                  >
                    All Security
                  </button>
                  {Object.keys(groupedData[hotel])
                    .filter((email) => {
                      const user = users.find((u) => u.email === email);
                      return user?.role === "security";
                    })
                    .map((email) => (
                      <button
                        key={email}
                        className={`tab-btn ${selectedUser === email ? "active selected-email" : ""}`}
                        onClick={() => setSelectedUser(email)}
                      >
                        {email} (Security)
                      </button>
                    ))}
                </div>

                {/* Table - only show if security */}
                {(() => {
                  const user = users.find((u) => u.email === selectedUser);
                  if (selectedUser !== "all" && user?.role !== "security") return null;

                  const filteredReviews = getFilteredHotelReviews(hotel, selectedUser);

                  return filteredReviews.length > 0 ? (
                    <table className="review-table">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>QR Data</th>
                          <th>Company Issues</th>
                          <th>Maintenance Issues</th>
                          <th>Image</th>
                          <th>Location</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredReviews.map((review) => {
                          const reviewDate = review.createdAt?.toDate ? review.createdAt.toDate() : null;
                          const isToday = reviewDate && reviewDate.toDateString() === new Date().toDateString();
                          const formattedDateTime = reviewDate
                            ? `${reviewDate.toLocaleDateString("en-GB")} ${reviewDate.toLocaleTimeString("en-GB", {
                                hour: "2-digit",
                                minute: "2-digit",
                                second: "2-digit",
                              })}`
                            : "";

                          return (
                            <tr key={review.id} className={`${isToday ? "today-review" : "older-review"}`}>
                              <td>{formattedDateTime}</td>
                              <td>{review.qrData || "N/A"}</td>
                              <td>{review.issueHotel}</td>
                              <td>{review.issueMaintenance}</td>
                              <td>
                                {review.imageUrls && review.imageUrls.length > 0 ? (
                                  <div className="thumbnail-row">
                                    {review.imageUrls.map((url, idx) => (
                                      <img
                                        key={idx}
                                        src={url}
                                        alt={`Uploaded ${idx + 1}`}
                                        className="review-thumbnail"
                                        onClick={() => setSelectedImage(url)}
                                      />
                                    ))}
                                  </div>
                                ) : (
                                  "No image"
                                )}
                              </td>
                              <td>
                                {review.location?.lat && review.location?.lng ? (
                                  <a
                                    href={`https://www.google.com/maps?q=${review.location.lat},${review.location.lng}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    View Location
                                  </a>
                                ) : (
                                  "No Location"
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  ) : (
                    <p className="no-data-message">No security submissions found for the selected date range.</p>
                  );
                })()}

                 {selectedImage && (
                  <div className="image-modal" onClick={() => setSelectedImage(null)}>
                    <span className="close-btn">&times;</span>
                    <img src={selectedImage} alt="Full view" className="modal-content" />
                  </div>
                  )}
            </div>
            </div>
        ))}
    </div>
  );
}

export default Viewsptxt;